module.exports = __webpack_public_path__ + "assets/img/403e-az.svg";